import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8debdf28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed-bottom-right" }
const _hoisted_2 = {
  key: 0,
  class: "icon icon-camera-plus"
}
const _hoisted_3 = {
  key: 1,
  class: "icon icon-plus"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, _mergeProps(_ctx.$attrs, {
      type: "primary",
      circle: ""
    }), {
      default: _withCtx(() => [
        (_ctx.usePhotoIcon)
          ? (_openBlock(), _createElementBlock("i", _hoisted_2))
          : (_openBlock(), _createElementBlock("i", _hoisted_3))
      ]),
      _: 1
    }, 16)
  ]))
}